import { RequireOnly } from '@pelicargo/types';
import { Quote, Request, ShipmentStatus } from '@prisma/client';

export const shipmentStatusUpdateMessages = (request: RequireOnly<Request, 'id' | 'shipment_status'>, quote: Quote) => {
  const info = `R${request.id} from ${quote.origin_airport_id} to ${quote.destination_airport_id}`;
  switch (request.shipment_status) {
    case ShipmentStatus.PICKUP_COMPLETE:
      return `Please note your cargo has been picked up for ${info}.`;
    case ShipmentStatus.AIRLINE_ACCEPTED:
      return `Please note your cargo has been delivered to ${quote.provider_id} for ${info}.`;
    case ShipmentStatus.AT_WAREHOUSE:
      return `Please note that your cargo has arrived at the warehouse for ${info}.`;
    case ShipmentStatus.OUT_FOR_DELIVERY:
      return `Please note that your cargo is out for delivery for ${info}.`;
    case ShipmentStatus.ARRIVED:
      return `Please note that R${request.id} from ${quote.origin_airport_id} has arrived at ${quote.destination_airport_id}.`;
    case ShipmentStatus.DELIVERED:
      return `Please note that ${info} has been delivered to its destination.`;
    case ShipmentStatus.ON_HOLD:
      return `Please note that your cargo has been put on hold for ${info}.`;
    case ShipmentStatus.PICKUP_SCHEDULED:
      return `Please note that your cargo has been scheduled to be picked up for ${info}.`;
    case ShipmentStatus.DEPARTED:
      return `Please note that ${info} has departed from ${quote.origin_airport_id}.`;
    default:
      // Not specified
      return '';
  }
};
